export const ACTIVITY_TIMELINE_EVENT = 'ACTIVITY_TIMELINE_EVENT';